import * as types from './constants';

export const increment = () => {

    return {
        type: types.INCREMENT_VALUE
    };
};

export const decrement = () => {

    return {
        type: types.DECREMENT_VALUE
    };
};



// WEBPACK FOOTER //
// ./src/containers/CounterPage/actions.js